window.addEventListener('load', () => {

	document.addEventListener('shopify:section:load', function (event) {
		const section = event.target;

		if (section.classList.contains('product-section')) {
			window.dispatchEvent(new Event('resize'));
		}
	});
});

/**
 *  Mega menu blocks: the header's mega menu panels open on hover and focus
 *  only, so selecting a mega menu block in the editor would show nothing. A
 *  top-level menu item carries the attributes of the block whose panel it
 *  shows (header-full-menu.liquid), so the editor sends that block's select
 *  and deselect events to the item, and menu-item--editor-open keeps its
 *  panel open while the block is selected (_full-menu.scss). Where the full
 *  menu is hidden (the mobile preview, or the drawer menu on desktop), the
 *  drawer opens at the item's submenu instead. This file loads in the theme
 *  editor only (layout/theme.liquid).
 */
(function () {
	const openClass = 'menu-item--editor-open';
	let drawerOpenedHere = false;
	let closeTimer = null;

	const menuItem = (event) => {
		const target = event.target;
		return target instanceof Element ? target.closest('.thb-full-menu > .menu-item-has-megamenu') : null;
	};

	// The drawer lists the same top-level items in the same order.
	const openInDrawer = (item) => {
		const drawer = document.getElementById('mobile-menu');
		const toggle = document.querySelector('.mobile-toggle');
		const index = Array.prototype.indexOf.call(item.parentElement.children, item);
		const details = drawer && drawer.querySelector(`.mobile-menu > li:nth-child(${index + 1}) > details`);
		if (!details || !toggle) return;
		if (!drawer.classList.contains('active')) {
			toggle.click();
			drawerOpenedHere = true;
		}
		// Back out of a submenu an earlier selection opened.
		drawer.querySelectorAll('.mobile-menu > li > details.menu-opening').forEach((open) => {
			if (open !== details) open.querySelector(':scope > .sub-menu .parent-link-back--button')?.click();
		});
		// The arrow opens the submenu whether or not the parent link is a link.
		if (!details.classList.contains('menu-opening')) details.querySelector(':scope > summary .link-forward')?.click();
	};

	document.addEventListener('shopify:block:select', (event) => {
		const item = menuItem(event);
		if (!item) return;
		clearTimeout(closeTimer);
		document.querySelectorAll('.thb-full-menu > .menu-item--editor-open').forEach((open) => {
			if (open !== item) open.classList.remove(openClass);
		});
		item.classList.add(openClass);
		if (!item.getClientRects().length) openInDrawer(item);
	});

	document.addEventListener('shopify:block:deselect', (event) => {
		const item = menuItem(event);
		if (!item) return;
		item.classList.remove(openClass);
		// Selecting another block deselects this one first: close the drawer
		// only if no selection follows.
		clearTimeout(closeTimer);
		closeTimer = setTimeout(() => {
			const drawer = document.getElementById('mobile-menu');
			if (drawerOpenedHere && drawer && drawer.classList.contains('active')) document.querySelector('.mobile-toggle')?.click();
			drawerOpenedHere = false;
		}, 100);
	});

	// A setting change renders the header again, and the new header removes
	// the old drawer (header.js moved it out to #wrapper) without closing
	// it. OverlayManager would keep the detached drawer on its stack: the
	// dim and scroll lock stay with no drawer showing, and its focus trap
	// swallows every Tab. So the open drawer closes as its section goes.
	// drawerOpenedHere is kept: the block select that follows the render
	// opens the new drawer at the same item.
	document.addEventListener('shopify:section:unload', (event) => {
		const drawer = document.getElementById('mobile-menu');
		if (!drawer || typeof OverlayManager === 'undefined' || !OverlayManager.isOpen(drawer)) return;
		if (event.target instanceof Element && event.target.querySelector('theme-header')) OverlayManager.close(drawer);
	});
})();
